import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SvgIconComponent } from '@ngneat/svg-icon'
import { InputComponent } from './components/input/input.component'
import { ButtonComponent } from './components/button/button.component'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { GooglePlaceInputComponent } from './components/google-place-input/google-place-input.component'
import { MatIconModule } from '@angular/material/icon'
import { ButtonGroupComponent } from './components/button-group/button-group.component'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { DateAdapter, MatNativeDateModule } from '@angular/material/core'
import { CheckboxComponent } from './components/checkbox/checkbox.component'
import { ChipInputComponent } from './components/chip-input/chip-input.component'
import { PaginationComponent } from './components/pagination/pagination.component'
import { TabsComponent } from './components/tabs/tabs.component'
import { FooterComponent } from './components/footer/footer.component'
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component'
import { RadioComponent } from './components/radio/radio.component'
import { SliderComponent } from './components/slider/slider.component'
import { InputRangeDateComponent } from './components/input-range-date/input-range-date.component'
import { NoReportBannerComponent } from './components/no-report-banner/no-report-banner.component'
import { AutofocusDirective } from './directives/auto-focus.directive'
import { FilterButtonComponent } from './components/filter-button/filter-button.component'
import { TableChartToggleComponent } from './components/table-chart-toggle/table-chart-toggle.component'
import { GoogleMapsModule } from '@angular/google-maps'
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter'
import { CheckboxElementComponent } from './components/checkbox-element/checkbox-element.component'
import { SafeHtmlPipe } from './pipes/safe-html.pipe'
import { SafeUrlPipe } from './pipes/safe-url.pipe'
import { StripHtmlPipe } from './pipes/strip-html.pipe'
import { RichTextPipe } from './pipes/rich-text.pipe'
import { UtcToLocalDatePipe } from './pipes/utc-to-local-date.pipe'
import { SearchPillsComponent } from './components/search-pills/search-pills.component'
import { ImageLightboxComponent } from './components/image-lightbox/image-lightbox.component'
import { MatMenuModule } from '@angular/material/menu'
import { EnterViewportDirective } from './directives/enter-viewport.directive'
import { CustomDateAdapter } from './date-adaptor/custom-date.adapter'
import { CleanNumberPipe } from './pipes/clean-number.pipe'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SvgIconComponent,
    NgxMaskDirective,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    GoogleMapsModule,
    MatMomentDateModule,
    MatMenuModule
  ],
  declarations: [
    AutofocusDirective,
    EnterViewportDirective,
    SafeUrlPipe,
    SafeHtmlPipe,
    StripHtmlPipe,
    RichTextPipe,
    CleanNumberPipe,
    UtcToLocalDatePipe,
    InputComponent,
    ButtonComponent,
    GooglePlaceInputComponent,
    ButtonGroupComponent,
    CheckboxComponent,
    ChipInputComponent,
    PaginationComponent,
    TabsComponent,
    FooterComponent,
    LoadingSpinnerComponent,
    RadioComponent,
    SliderComponent,
    InputRangeDateComponent,
    NoReportBannerComponent,
    FilterButtonComponent,
    TableChartToggleComponent,
    CheckboxElementComponent,
    SearchPillsComponent,
    ImageLightboxComponent
  ],
  exports: [
    EnterViewportDirective,
    SafeUrlPipe,
    SafeHtmlPipe,
    StripHtmlPipe,
    RichTextPipe,
    CleanNumberPipe,
    UtcToLocalDatePipe,
    InputComponent,
    ButtonComponent,
    GooglePlaceInputComponent,
    ButtonGroupComponent,
    CheckboxComponent,
    ChipInputComponent,
    PaginationComponent,
    TabsComponent,
    FooterComponent,
    LoadingSpinnerComponent,
    RadioComponent,
    SliderComponent,
    InputRangeDateComponent,
    NoReportBannerComponent,
    FilterButtonComponent,
    TableChartToggleComponent,
    CheckboxElementComponent,
    SearchPillsComponent,
    ImageLightboxComponent
  ],
  providers: [
    provideNgxMask(),
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ]
})
export class CoreUiModule {}
